var _path, _path2;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHide = function SvgHide(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5232 5.80915C15.9918 6.22841 16.3864 6.63533 16.6823 6.95594C16.8868 7.18253 17 7.47691 17 7.78213C17 8.08735 16.8868 8.38173 16.6823 8.60832C15.3875 10.0017 12.4404 12.7146 9 12.7146H8.50675M5.14035 11.6418C3.71196 10.8418 2.4213 9.81759 1.3177 8.60832C1.1132 8.38173 1 8.08735 1 7.78213C1 7.47691 1.1132 7.18253 1.3177 6.95594C2.61247 5.56252 5.55961 2.84967 9 2.84967C10.3561 2.87802 11.6834 3.24693 12.8596 3.92248M15.7821 1L2.21787 14.5643",
    stroke: "#F8F8F8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26074 9.52133C6.7976 9.06094 6.53596 8.43566 6.5332 7.78263C6.5332 7.12855 6.79304 6.50126 7.25554 6.03875C7.71805 5.57624 8.34535 5.31641 8.99943 5.31641C9.65246 5.31916 10.2777 5.5808 10.7381 6.04394M11.1451 9.01575C10.9255 9.39099 10.6107 9.70153 10.2325 9.91592",
    stroke: "#F8F8F8",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHide, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hide.b68108e9.svg";
export { ForwardRef as ReactComponent };